import LegalLayout from "./LegalLayout";
import { COMPANY } from "@/legal/companyInfo";

const addr = `${COMPANY.address.street}, ${COMPANY.address.zip} ${COMPANY.address.city}, ${COMPANY.address.country}`;

export default function Processing() {
  return (
    <LegalLayout
      title="Registre des traitements"
      subtitle={`Registre tenu conformément à l'art. 12 nLPD. Dernière mise à jour : ${COMPANY.lastUpdated}.`}
    >
      <section>
        <h2>Responsable du traitement</h2>
        <p>
          <strong>{COMPANY.legalName}</strong> — {COMPANY.legalForm}<br/>
          IDE : {COMPANY.ide}<br/>
          Inscrite au registre du commerce du canton du Valais<br/>
          Siège : {addr}<br/>
          Email dédié : <a href={`mailto:${COMPANY.dpoEmail}`}>{COMPANY.dpoEmail}</a>
        </p>
      </section>

      <section>
        <h2>Traitement n°1 — Gestion des comptes utilisateurs</h2>
        <ul>
          <li><strong>Finalités</strong> : création, authentification et gestion des comptes des Clients.</li>
          <li><strong>Base légale</strong> : exécution du contrat (souscription à l'abonnement Oresto).</li>
          <li><strong>Catégories de personnes concernées</strong> : Clients d'Oresto (restaurateurs).</li>
          <li><strong>Catégories de données</strong> : email, mot de passe (chiffré bcrypt), nom, date de création, date de dernière connexion.</li>
          <li><strong>Destinataires</strong> : personnel technique restreint d'Oresto ; Emergent Labs Inc. (hébergement, États-Unis).</li>
          <li><strong>Transferts à l'étranger</strong> : États-Unis (hébergeur Emergent Labs Inc.), avec garanties contractuelles.</li>
          <li><strong>Durée de conservation</strong> : durée de l'abonnement + 90 jours après résiliation.</li>
          <li><strong>Mesures de sécurité</strong> : chiffrement bcrypt des mots de passe, cookies httpOnly/Secure, HTTPS/TLS 1.3, isolation par user_id.</li>
        </ul>
      </section>

      <section>
        <h2>Traitement n°2 — Données de l'établissement</h2>
        <ul>
          <li><strong>Finalités</strong> : personnaliser les rapports PDF, calculer la TVA cantonale et afficher le contexte de l'utilisateur.</li>
          <li><strong>Base légale</strong> : exécution du contrat.</li>
          <li><strong>Catégories de personnes concernées</strong> : Clients d'Oresto.</li>
          <li><strong>Catégories de données</strong> : nom de l'établissement, adresse, canton, numéro TVA, logo (image).</li>
          <li><strong>Destinataires</strong> : Client uniquement (personne d'autre n'y accède, sauf support technique demandé par le Client).</li>
          <li><strong>Transferts à l'étranger</strong> : États-Unis (hébergeur Emergent Labs Inc.), avec garanties contractuelles.</li>
          <li><strong>Durée de conservation</strong> : durée de l'abonnement + 90 jours.</li>
          <li><strong>Mesures de sécurité</strong> : idem traitement n°1.</li>
        </ul>
      </section>

      <section>
        <h2>Traitement n°3 — Données d'exploitation (caisses et factures)</h2>
        <ul>
          <li><strong>Finalités</strong> : permettre au Client de saisir, consulter et exporter ses données de gestion (CA, TVA, factures fournisseurs).</li>
          <li><strong>Base légale</strong> : exécution du contrat.</li>
          <li><strong>Catégories de personnes concernées</strong> : Clients (les données saisies concernent uniquement l'activité commerciale du Client, pas des personnes physiques identifiables autres que le Client lui-même et les fournisseurs qu'il enregistre).</li>
          <li><strong>Catégories de données</strong> : chiffres d'affaires quotidiens, TVA calculée, nombre de couverts, factures fournisseurs (nom du fournisseur, montant, échéance, statut).</li>
          <li><strong>Destinataires</strong> : Client uniquement.</li>
          <li><strong>Transferts à l'étranger</strong> : États-Unis (hébergeur Emergent Labs Inc.), avec garanties contractuelles.</li>
          <li><strong>Durée de conservation</strong> : durée de l'abonnement + 90 jours. Les données comptables associées à un paiement sont conservées 10 ans (art. 958f CO).</li>
          <li><strong>Mesures de sécurité</strong> : isolation par user_id sur chaque requête, HTTPS/TLS 1.3, sauvegarde régulière.</li>
        </ul>
      </section>

      <section>
        <h2>Traitement n°4 — Paiement et abonnement</h2>
        <ul>
          <li><strong>Finalités</strong> : encaisser l'abonnement mensuel/annuel du Client et émettre les reçus.</li>
          <li><strong>Base légale</strong> : exécution du contrat + obligation légale (comptabilité).</li>
          <li><strong>Catégories de personnes concernées</strong> : Clients ayant souscrit un abonnement payant.</li>
          <li><strong>Catégories de données</strong> : formule choisie, montant, date de paiement, référence de transaction Stripe. <strong>Aucune donnée de carte bancaire n'est stockée par Oresto.</strong></li>
          <li><strong>Destinataires</strong> : Stripe Payments Europe (Dublin, Irlande) ; personnel comptable d'Oresto.</li>
          <li><strong>Transferts à l'étranger</strong> : Irlande / États-Unis (Stripe), avec garanties contractuelles.</li>
          <li><strong>Durée de conservation</strong> : 10 ans (obligation comptable suisse, art. 958f CO).</li>
          <li><strong>Mesures de sécurité</strong> : PCI-DSS niveau 1 (Stripe), HTTPS/TLS 1.3.</li>
        </ul>
      </section>

      <section>
        <h2>Traitement n°5 — Emails transactionnels</h2>
        <ul>
          <li><strong>Finalités</strong> : envoyer les emails de bienvenue, de réinitialisation de mot de passe, les reçus de paiement et les alertes techniques.</li>
          <li><strong>Base légale</strong> : exécution du contrat.</li>
          <li><strong>Catégories de personnes concernées</strong> : Clients.</li>
          <li><strong>Catégories de données</strong> : adresse email, contenu de l'email (limité à ce qui est nécessaire).</li>
          <li><strong>Destinataires</strong> : Resend, Inc. (États-Unis).</li>
          <li><strong>Transferts hors UE</strong> : oui, vers les États-Unis. Encadrement juridique : Clauses Contractuelles Types de la Commission Européenne (SCC) signées avec Resend.</li>
          <li><strong>Durée de conservation</strong> : les emails ne sont pas archivés côté Oresto ; Resend conserve les métadonnées d'envoi 30 jours.</li>
          <li><strong>Mesures de sécurité</strong> : TLS pour la transmission, DKIM/SPF/DMARC pour l'authentification des emails, aucun contenu sensible dans les emails.</li>
        </ul>
      </section>

      <section>
        <h2>Traitement n°6 — Support client</h2>
        <ul>
          <li><strong>Finalités</strong> : répondre aux demandes de support par email.</li>
          <li><strong>Base légale</strong> : exécution du contrat.</li>
          <li><strong>Catégories de personnes concernées</strong> : Clients contactant le support.</li>
          <li><strong>Catégories de données</strong> : email, contenu de la demande, éventuelles captures d'écran fournies par le Client.</li>
          <li><strong>Destinataires</strong> : personnel de support d'Oresto.</li>
          <li><strong>Transferts à l'étranger</strong> : États-Unis (hébergeur Emergent Labs Inc.), avec garanties contractuelles.</li>
          <li><strong>Durée de conservation</strong> : 3 ans à compter de la clôture du ticket.</li>
          <li><strong>Mesures de sécurité</strong> : accès restreint au personnel support, formation confidentialité.</li>
        </ul>
      </section>

      <section>
        <h2>Traitement n°7 — Statistiques d'usage anonymisées</h2>
        <ul>
          <li><strong>Finalités</strong> : améliorer le produit en comprenant les fonctionnalités les plus utilisées.</li>
          <li><strong>Base légale</strong> : intérêt légitime.</li>
          <li><strong>Catégories de personnes concernées</strong> : tous les visiteurs et Clients.</li>
          <li><strong>Catégories de données</strong> : événements techniques anonymisés (page vue, clic, durée). Aucune donnée personnelle directement identifiante.</li>
          <li><strong>Destinataires</strong> : PostHog (via Emergent).</li>
          <li><strong>Transferts hors UE</strong> : possibles selon la configuration PostHog choisie ; encadrement par SCC.</li>
          <li><strong>Durée de conservation</strong> : 6 mois.</li>
          <li><strong>Mesures de sécurité</strong> : anonymisation à la source, aucun identifiant personnel transmis.</li>
        </ul>
      </section>

      <section>
        <h2>Mise à jour du registre</h2>
        <p>Ce registre est révisé au minimum une fois par an, et à chaque évolution significative des traitements. La version en vigueur est publiée sur <a href="/registre-traitements">{COMPANY.website}/registre-traitements</a>.</p>
      </section>
    </LegalLayout>
  );
}
